module.exports = __webpack_public_path__ + "static/img/icon3.be025e2c.png";